export const getNumberOfRetries = (sentToEngineTimestamp?: number) => {
  if (!sentToEngineTimestamp) {
    return 120;
  }
  const secondsLast = Math.floor((Date.now() - sentToEngineTimestamp) / 1000);
  // after 30 sec the query must be in the query history
  return secondsLast > 30 ? 5 : 120;
};
